(function(window)
{
	// Create the new application
	window.app = new heist.CookieHeist({
		name: "Detective Elmo The Cookie Case",
		fps: 30,
		resizeElement: window,
		configPath: "assets/config/config.json",
		canvasId: "stage",
		display: springroll.PixiDisplay,
		displayOptions:	{
			clearView: true,
			transparent: true,
			antiAlias: true,
			keepMouseover: true
		}
	});
	
}(window));